import { AxiosInstance } from 'axios';

import axiosInstance, { builderInstance, notificationsInstance } from 'api/base';
import { IAllPageFilters } from 'utils/types';

export enum FILTER_DATA_INSTANCES {
  CORE = 'CORE',
  INTEGRATION_BUILDER = 'INTEGRATION_BUILDER',
  NOTIFICATION_SERVICE = 'NOTIFICATION_SERVICE',
}

export const FILTER_DATA_AXIOS_INSTANCES: Record<FILTER_DATA_INSTANCES, AxiosInstance> = {
  CORE: axiosInstance,
  INTEGRATION_BUILDER: builderInstance,
  NOTIFICATION_SERVICE: notificationsInstance,
};

export interface IFilterData {
  fieldName: string;
  fieldValues: string[];
}

export interface IRequestFilterProps {
  field: string;
  instance?: FILTER_DATA_INSTANCES;
  pageFilters?: IAllPageFilters;
  prefix?: string;
}

export interface IRequestFilterQueryProps extends IRequestFilterProps {
  enabled: boolean;
  // Keep the queried field's own filter in the request. Off by default so filter
  // dropdowns still list every value; on for scope resolution that must honor it.
  keepFieldFilter?: boolean;
}
